export const fieldLengths = {
  orders: {
    account: 100,
    quoteNumber: 100,
    purchaseVehicle: 50,
    productType: 50,
    billToCompany: 150,
    billToAttention: 150,
    billToAddress1: 150,
    billToAddress2: 150,
    billToAddress3: 41,
    billToAddress4: 41,
    billToAddressCity: 150,
    billToAddressZip: 36,
    billToAddressState: 21,
    billToAddressCountry: 31,
    legacyBillTo: 200,
    legacyBillToAddress: 500,
    shipToCompany: 150,
    shipToAttention: 150,
    shipToAddress1: 150,
    shipToAddress2: 150,
    shipToAddress3: 41,
    shipToAddress4: 41,
    shipToAddressCity: 150,
    shipToAddressZip: 36,
    shipToAddressState: 21,
    shipToAddressCountry: 31,
    legacyShipTo: 200,
    legacyShipToAddress: 500,
    customerPO: 100,
    dpasRating: 50,
    deliveryInstructions: 2000,
    specialInstructions: 2000,
    invoicingPlatform: 100,
    securityRequirement: 10,
    uidRequirement: 500,
    eplRequirement: 500,
    repCode: 5,
    govPaymentTerms: 100,
    vendorPaymentTerms: 150,
    status: 25,
    statusComment: 2000,
    salesOrderNumber: 10,
    netsuiteSalesOrderId: 10,
    division: 50,
    endUserType: 50,
    location: 50,
    receiverContactName: 100,
    receiverContactEmail: 100,
    receiverContactPhone: 60,
    licenseContactName: 100,
    licenseContactEmail: 100,
    licenseContactPhone: 60,
    class: 50,
    opportunity: 255,
    urgentReason: 20,
    scrmComment: 2000,
    contractNumber: 50,
    stn: 100,
    govAwardNumber: 100,
  },
  repCodes: {
    repCode: 5,
    insideSalesRep: 200,
    accountExecutive: 100,
    engineer: 100,
    isrEmail: 50,
    aeEmail: 50,
    engEmail: 50,
  },
  rejections: {
    comments: 5000,
  },
  lineItems: {
    productDescription: 4095,
    supplierPartNumber: 4095,
    productCategory: 100,
    supplier: 200,
    class: 50,
    kit: 250,
    manufacturer: 200,
    mfrPartNum: 50,
    shipToCompany: 41,
    shipToAttention: 150,
    shipToAddress1: 41,
    shipToAddress2: 41,
    shipToAddressCity: 31,
    shipToAddressZip: 13,
    shipToAddressState: 21,
    shipToAddressCountry: 31,
    receiverContactName: 100,
    receiverContactEmail: 100,
    receiverContactPhone: 60,
    contractCatalog: 100,
    countryOfOrigin: 100,
    serviceTag: 100,
    serialNumber: 100,
    unitOfMeasure: 100,
    notes: 4096,
    netsuiteVendor: 200,
    displayPartNumber: 250,
  },
}
